'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import H2 from 'UIComponents/elements/headings/H2';
import UIList from 'UIComponents/list/UIList';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import { EERIE, OLAF } from 'HubStyleTokens/colors';
import PlaceholderCertificate from '../../PlaceholderCertificate';
import useMediaQuery from '../../../hooks/useMediaQuery';
import ModalTile, { ModalTileSection } from './ModalTile';
const CertificateTile = styled(ModalTile).withConfig({
  displayName: "OverviewModalCertificateSection__CertificateTile",
  componentId: "sc-8805k8-0"
})(["background:", ";margin-top:0 !important;color:", ";height:100%;max-height:210px;@media (min-width:850px){height:210px;}"], EERIE, OLAF);
const SectionWrapper = styled.div.withConfig({
  displayName: "OverviewModalCertificateSection__SectionWrapper",
  componentId: "sc-8805k8-1"
})(["display:flex;align-items:center;justify-content:center;margin-bottom:-32px;height:100%;"]);
const CertificateWrapper = styled.div.withConfig({
  displayName: "OverviewModalCertificateSection__CertificateWrapper",
  componentId: "sc-8805k8-2"
})(["position:relative;height:230px;width:300px;@media (max-width:850px){width:min(100%,300px);height:0;padding-top:min(77%,230px);}margin-top:-42px;margin-bottom:-42px;z-index:1;"]);
const CertificatePoint = styled(FormattedMessage).withConfig({
  displayName: "OverviewModalCertificateSection__CertificatePoint",
  componentId: "sc-8805k8-3"
})(["font-weight:400;"]);

const OverviewModalCertificateSection = ({
  title,
  iconUrl
}) => {
  const isLargerThanModalWidth = useMediaQuery('(min-width: 850px)');
  return /*#__PURE__*/_jsx(CertificateTile, {
    children: /*#__PURE__*/_jsx(ModalTileSection, {
      style: {
        height: '100%'
      },
      children: /*#__PURE__*/_jsxs(SectionWrapper, {
        children: [/*#__PURE__*/_jsx(CertificateWrapper, {
          children: /*#__PURE__*/_jsx(PlaceholderCertificate, {
            iconUrl: iconUrl,
            title: title
          })
        }), isLargerThanModalWidth && /*#__PURE__*/_jsxs("div", {
          className: "m-left-6",
          children: [/*#__PURE__*/_jsx(H2, {
            className: "m-bottom-1",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.overviewModal.certificationSection.title"
            })
          }), /*#__PURE__*/_jsxs(UIList, {
            style: {
              paddingInlineStart: 30,
              marginBottom: 0
            },
            styled: true,
            children: [/*#__PURE__*/_jsx(CertificatePoint, {
              message: "learningCenter.overviewModal.certificationSection.point1"
            }), /*#__PURE__*/_jsx(CertificatePoint, {
              message: "learningCenter.overviewModal.certificationSection.point2"
            })]
          })]
        })]
      })
    })
  });
};

export default OverviewModalCertificateSection;